import css from './empty-placeholder.module.scss';

export default function EmptyPlaceholder() {
  return (
    <div className={css.container}>
      <h2>Наразі тут пусто</h2>
      <p>Завітайте трохи згодом, щось обов’язково з’явиться</p>
    </div>
  );
}
